import { NEW_NOTIFICATION, READ_ALL_NOTIFICATIONS, READ_NOTIFICATION } from '../action.types'

import initialState from '../initial.state'

export default (state = initialState.notifications, action) => {
  switch (action.type) {
    case NEW_NOTIFICATION:
      return state.some(({ id }) => id === action.notification.id) ? state : [...state, action.notification]
    case READ_ALL_NOTIFICATIONS:
      return []
    case READ_NOTIFICATION:
      return state.filter(notification => notification.id !== action.notification.id)
    default:
      return state
  }
}

